import React from 'react'
import QP from "./QP.jpg"
import "./QualityPolicy.css"

function QualityPolicy() {
  return (
    <div className="Quality">
        <div className="head">
          <p>Quality Policy</p>
          </div>
        <img src={QP}></img>
        </div>
  )
}

export default QualityPolicy